export default __webpack_public_path__ + "static/media/email-dish.f65f9521.png";